import React, { Fragment } from 'react'


const Filter = ({
  id,
  register,
  handleSubmit,
  onReset,
  types = [],
  filters,
  ...settings
}) => {

  /*
  console.log(settings);

  const years  = [active_years_start, ...Array.from({length: (active_years_end - active_years_start)},(v,k)=> {
    return active_years_start + (k+1)
  })]
  console.log(years)*/

  return (
    <form className="map__filter" onSubmit={handleSubmit}>
      <div className="map__filter-fields">
        <div className="map__filter-field">
          <input type="text" placeholder="Search" {...register('keywords', {
            value: filters.keywords
          })} inputMode="search" id={`keywords__${id}`} />
          <label htmlFor={`keywords__${id}`}>Filter by title or keyword</label>
        </div>
        <div className="map__filter-field">
          <fieldset className="radios">
            <legend>Filter by tide prediction type</legend>

              <label htmlFor={`type__offset`}>
                <input type="radio" {...register('type')} id={`type__offset`} defaultValue={'offset'} />
                <span>Offset</span>
              </label>
              <label htmlFor={`type__prediction`}>
                <input type="radio" {...register('type')} id={`type__prediction`} defaultValue={'prediction'} />
                <span>Daily Predictions</span>
              </label>
          </fieldset>
        </div>
      </div>

      <div className="map__filter-buttons">
        <button type="submit">Submit</button>
        <button type="button" onClick={onReset}>Reset</button>
      </div>
    </form>
  )
}
export default Filter
